import { installStorageProxy } from '../utils/storageProxy';

installStorageProxy();

